var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_ORGANIZATIONS) &&
    _vm.organization &&
    _vm.organization.id
  )?_c('div',[_c('router-link',{attrs:{"to":{ name: 'View Organization', params: { id: _vm.organization.id } }}},[_vm._v(" "+_vm._s(`${_vm.organization.name}`)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }